import { FetchPolicy } from '@bingads-webui-react/overreact';
import {
  PerformanceTimeSeriesResponseContract,
  PerformanceTimeSeriesRequestContract,
} from './contract';

export const refetchRequestContract = new PerformanceTimeSeriesRequestContract({
  fetchPolicy: FetchPolicy.NetworkOnly,
});

export const refetchResponseContract = new PerformanceTimeSeriesResponseContract({
  requestContract: refetchRequestContract,
});
